import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {FormService} from '@services/form.service';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {UserService} from '@services/user.service';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import {AlertService} from '@services/alert.service';

@Component({
    selector: 'app-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {
    accountForm: UntypedFormGroup;
    user: User = Object.assign({}, EMPTY_USER);
    loading = false;
    duration = '';
    plan = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<AccountComponent>,
        private formBuilder: UntypedFormBuilder,
        public formService: FormService,
        public authenticationService: AuthenticationService,
        public userService: UserService,
        private http: HttpClient,
        private alertService: AlertService,
    ) {
        this.duration = data.duration;
        this.plan = data.plan;
    }

    ngOnInit(): void {

        this.accountForm = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            adress: [''],
            city: [''],
            zip_code: [''],
            company_name: [''],
            mobile: [''],
        });

        this.user = this.authenticationService.currentUser;
        let data = {
            mobile: "",
        }
        if (this.user.pro_data !== "") {
            data = JSON.parse(this.user.pro_data);
        }

        this.accountForm = this.formBuilder.group({
            firstName: [this.user.firstname, Validators.required],
            lastName: [this.user.lastname, Validators.required],
            plan: [this.user.plan],
            adress: [this.user.adress],
            city: [this.user.city],
            zip_code: [this.user.zip_code],
            company_name: [this.user.company_name],
            mobile: [data.mobile === undefined ? '' : data.mobile],
        });
    }

    setDuration(duration) {
        this.duration = duration;
    }

    onYesClick(): void {
        if (this.accountForm.invalid) {
            this.dialogRef.close(true);
        }

        let form = this.accountForm.getRawValue();
        Object.keys(form).forEach((k) => {
            this.user[k] = form[k];
        });
        this.user.pro_data = JSON.stringify({mobile: form['mobile']});

        this.http.put(environment.apiUrl + 'app/user', this.user).subscribe(result => {
            this.loading = true
            this.dialogRef.close(this.duration);
        }, error => {
            this.alertService.error('La mail renseigné est déja utilisé pour un autre compte.');
            this.loading = false;
        });
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }
}
